<template>
  <div class="has-background-white">
    <section class="hero is-flex d-placecontent">
      <div
        class="animation d-grid has-text-centered-mobile"
        :class="
          screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
        "
      >
        <div class="">
          <h3
            class="has-text-weight-semibold is-size-5-mobile is-size-3-tablet"
          >
            {{ $t('Get Jobseekers') }}
          </h3>
          <h4
            class="has-text-weight-semibold is-size-2-mobile is-size-1-tablet mb-5"
          >
            {{ $t('Like you are looking for') }}
          </h4>
          <p class="is-size-4 mb-2">{{ $t('Post a Job Today') }}!</p>
          <div class="m-d-grid gap-1 is-flex">
            <button
              id="btn-post-a-job"
              class="button is-employer"
              @click="gotoJobPost()"
              v-text="
                $auth.loggedIn && $auth.user.has_free_post_balance
                  ? $t('Post a Bonus Job')
                  : $t('Post Job')
              "
            ></button>
            <button
              id="btn-sign-in"
              v-if="!$auth.loggedIn"
              class="button is-jobseeker"
              @click="
                setDialog({
                  display: true,
                  type: 'employer-sign-in',
                  extraInfo: 'employer-sign-in'
                })
              "
            >
              {{ $t('signIn') }}
            </button>
          </div>
        </div>
        <div class="">
          <div class="carousel absolute overflow-hidden display-none">
            <img
              class="carousel-item absolute active"
              src="@/static/images/account/chef.png"
              alt="rojgari picture"
            />
            <img
              class="carousel-item absolute"
              src="@/static/images/account/del.png"
              alt="rojgari picture"
            />
            <img
              class="carousel-item absolute"
              src="@/static/images/account/painter.png"
              alt="rojgari picture"
            />
            <img
              class="carousel-item absolute"
              src="@/static/images/account/eng.png"
              alt="rojgari picture"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="d-grid gap-1 background-color">
      <div
        class="map-nepal d-grid gap-1 has-text-centered d-placeitem has-text-white"
        :class="
          screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
        "
      >
        <div>
          <img
            src="@/static/images/account/map.png"
            alt="nepal map"
            class="lift-karade-img"
          />
          <p class="description has-text-centered is-size-6-desktop">
            {{ $t('Skilled and Experienced') }}
          </p>
        </div>
        <div class="boxes d-grid gap-1">
          <div
            v-for="item in counter"
            :key="item.title"
            class="background-color card-box d-placecontent has-text-white has-text-centered is-flex is-flex-direction-row lift-shadow pointer"
          >
            <p class="is-size-3 is-size-4-mobile has-text-weight-semibold">
              {{ item.title }}
            </p>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
      <div
        class="top-border signup-block has-text-centered has-text-white pa-5"
      >
        <p>
          {{ $t('Reliable Workers') }}
        </p>
        <p>
          {{ $t('Hiring Partnership') }}
        </p>
      </div>
    </section>

    <section class="d-grid gap-1 has-text-centered-mobile about-rojgari">
      <div
        :class="
          screen === 'mobile'
            ? 'is-flex align-center is-flex-wrap content-center'
            : ''
        "
        class="rojgari d-grid d-placeitem"
      >
        <div
          :class="
            screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
          "
          class="rojgari-com d-grid gap-1"
        >
          <h3 class="is-size-2 is-size-3-mobile has-text-weight-bold">
            {{ $t('About Rojgari') }}
          </h3>
          <p class="is-size-6-mobile">
            {{ $t('Brief') }}
          </p>
        </div>
        <img
          :class="screen === 'mobile' ? '' : 'mr-4'"
          class="lift-karade-img"
          src="@/static/images/account/rojgari.png"
          alt="rojgari"
        />
      </div>
    </section>
    <section class="d-grid gap-1 available-employer">
      <h3
        class="service is-size-2 is-size-3-mobile has-text-weight-bold has-text-centered"
        :class="
          screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
        "
      >
        {{ $t('You are looking for') }}
      </h3>
      <div
        class="employer-icon d-grid gap-1"
        :class="
          screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
        "
      >
        <div class="employer-box lift-shadow d-grid pa-4">
          <div
            class="has-text-centered d-flex d-placeitem d-placecontent vue-icon signup-block mb-3 pa-4"
          >
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-cloud-download')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Create an employer profile') }}
          </p>
        </div>
        <div class="employer-box lift-shadow d-grid pa-4">
          <div
            class="has-text-centered d-flex d-placeitem d-placecontent vue-icon signup-block mb-3 pa-4"
          >
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-file-info-alt')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Click on the post-job & fill details') }}
          </p>
        </div>
        <div class="employer-box lift-shadow d-grid pa-4">
          <div
            class="has-text-centered d-flex d-placeitem d-placecontent vue-icon signup-block mb-3 pa-4"
          >
            <vue-icon-base
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-cloud-meatball')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Get the job application') }}
          </p>
        </div>
        <div class="employer-box lift-shadow d-grid pa-4">
          <div
            class="has-text-centered d-flex d-placeitem d-placecontent vue-icon signup-block mb-3 pa-4"
          >
            <vue-icon-base
              class="has-text-centered"
              height="16"
              width="16"
              :path="$options.icons[$kc('uni-user-check')]"
            ></vue-icon-base>
          </div>
          <p class="has-text-centered">
            {{ $t('Select the preferred worker') }}
          </p>
        </div>
      </div>
      <div class="has-text-centered button-type d-grid gap-1">
        <div>
          <button
            id="btn-post-a-job"
            class="button is-employer"
            @click="gotoJobPost()"
            v-text="
              $auth.loggedIn && $auth.user.has_free_post_balance
                ? $t('Post a Bonus Job')
                : $t('Post Job')
            "
          ></button>
        </div>
      </div>
    </section>
    <section class="d-grid gap-1 avaliable-employer-work">
      <div
        class="employer-list d-grid gap-1"
        :class="
          screen === 'mobile' ? '' : 'padding-right-70px padding-left-70px'
        "
      >
        <h3 class="employer is-size-2 is-size-4-mobile has-text-weight-bold">
          {{ $t('List of available workers') }}
        </h3>
        <div class="is-flex is-flex-wrap">
          <p class="tag-color">{{ $t('Waiter/ Waitress') }}</p>
          <p class="tag-color">{{ $t('Barista') }}</p>
          <p class="tag-color">{{ $t('Security guard') }}</p>
          <p class="tag-color">{{ $t('Allrounder Cook') }}</p>
          <p class="tag-color">{{ $t('kitchen Helper') }}</p>
          <p class="tag-color">{{ $t('Front desk officer') }}</p>
          <p class="tag-color">{{ $t('Cleaner') }}</p>
          <p class="tag-color">{{ $t('Storekeeper') }}</p>
          <p class="tag-color">{{ $t('Delivery rider') }}</p>
          <p class="tag-color">{{ $t('Office runner') }}</p>
          <p class="tag-color">{{ $t('Electrician') }}</p>
          <p class="tag-color">{{ $t('housekeeping') }}</p>
          <p class="tag-color">{{ $t('Cashier') }}</p>
          <p class="tag-color">{{ $t('Office Assistant') }}</p>
          <p class="tag-color">{{ $t('bartender') }}</p>
          <p class="tag-color">{{ $t('Accountant') }}</p>
        </div>
      </div>
    </section>
    <section class="d-grid gap-1 sponser pb-0 px-0">
      <h3
        class="service has-text-centered has-text-weight-bold is-size-2 is-size-3-mobile"
      >
        {{ $t('Employers who are using our service') }}
      </h3>
      <top-employer></top-employer>
    </section>
    <footer
      class="footer-nav z-index-1"
      :class="{ sticky: isFooterSticky, hidden: isFooterHidden }"
    >
      <button
        id="btn-explore-jobseeker-insights"
        class="button rounded-10 is-employer my-3"
        @click="$router.push(localePath('jobseeker-insights'))"
        v-text="$t('Explore Jobseeker Insights')"
      ></button>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import VueIconBase from '@/components/Commons/VueIconBase'
import {
  uniCloudDownload,
  uniBuilding,
  uniFileInfoAlt,
  uniCloudMeatball,
  uniUserCheck
} from '@/helpers/icons'
import TopEmployer from '~/components/Homepage/TopEmployer.vue'
export default {
  icons: {
    uniCloudDownload,
    uniBuilding,
    uniFileInfoAlt,
    uniCloudMeatball,
    uniUserCheck
  },
  components: {
    VueIconBase,
    TopEmployer
  },
  data() {
    return {
      isFooterSticky: false,
      isFooterHidden: true,
      availabledetails: [],
      counter: [
        {
          title: this.$t('1,25,000+'),
          text: this.$t('Jobseekers Registered')
        },
        {
          title: this.$t('650+'),
          text: this.$t('Daily Application')
        },
        {
          title: this.$t('7,500+'),
          text: this.$t('Companies Registered')
        },
        {
          title: this.$t('15,500+'),
          text: this.$t('Workers who got Employed')
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', ['loggedIn']),
    ...mapGetters({ screen: 'getScreen' })
  },
  mounted() {
    this.transition()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const scroll = window.pageYOffset || document.documentElement.scrollTop

      if (scroll > 50) {
        this.isFooterSticky = true
        this.isFooterHidden = false
      } else {
        this.isFooterSticky = false
        this.isFooterHidden = true
      }
    },
    gotoJobPost() {
      if (this.$auth.loggedIn && this.$auth.user.employer_profile) {
        if (this.$auth.user.has_filled_initial_form) {
          if (
            (this.$auth.user.related_organizations.length &&
              this.$auth.user.is_purchase_available) ||
            this.$auth.user.has_free_post_balance
          ) {
            this.$nuxt.$emit('openinitialform')
          } else if (!this.$auth.user.is_purchase_available) {
            this.$router.push(
              this.localePath({
                name: 'pricing'
              })
            )
          } else {
            this.setDialog({ display: true, type: 'details' })
            this.notifyError(this.$t('Initial profile form not filled'))
          }
        } else {
          this.setDialog({ display: true, type: 'details' })
          this.notifyError(this.$t('Initial profile form not filled'))
        }
      } else {
        this.setDialog({
          display: true,
          type: 'employer-sign-in',
          extraInfo: 'employer-sign-in'
        })
        this.notifyError(
          this.$t('You need to login as an employer to post a job.')
        )
      }
    },
    transition() {
      const slides = document.getElementsByClassName('carousel-item')
      function addActive(slide) {
        if (slide) {
          slide.classList.add('active')
          return true
        } else {
          return false
        }
      }
      function removingActive(slide) {
        slide.classList.add('remove')
      }
      function removeActive(slide) {
        slide.classList.remove('active')
      }
      function removeRemove(slide) {
        slide.classList.remove('remove')
      }
      addActive(slides[0])
      setInterval(function () {
        for (let i = 0; i < slides.length; i++) {
          if (i + 1 === slides.length) {
            addActive(slides[0])
            setTimeout(removingActive, 200, slides[i])
            setTimeout(removeActive, 200, slides[i])
            setTimeout(removeRemove, 2000, slides[i])
          }
          if (slides[i].classList.contains('active')) {
            addActive(slides[i + 1])
            setTimeout(removingActive, 200, slides[i])
            setTimeout(removeActive, 200, slides[i])
            setTimeout(removeRemove, 2000, slides[i])
            break
          }
        }
      }, 8000)
    }
  }
}
</script>
<style scoped>
section {
  padding: 5rem;
}
.hero {
  background-image: url('/images/account/background.png');
  background-position: top;
  background-repeat: no-repeat;
  background-size: cover;
  height: 86vh;
  position: relative;
}
.d-grid {
  display: grid;
}
.animation {
  grid-template-columns: repeat(2, 1fr);
}
.animation h4 {
  line-height: 4.375rem;
}
.background-color {
  background: #b2522b;
}
.card-box {
  border: 0.125rem solid #ffffff;
  box-shadow: 0px 0.25rem 0.75rem rgb(0 0 0 / 25%);
  border-radius: 1rem;
  padding: 1.875rem 1.375rem;
  flex-direction: column;
}
.map-nepal {
  grid-template-columns: 1fr 1fr;
}
.map-nepal .boxes {
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 10rem;
}
.description,
.map-nepal,
.animation,
.background-color .top-border,
.rojgari,
.available-employer,
.employer-list,
.sponser {
  max-width: 84.375rem;
  width: 100%;
  margin: auto;
}
.map-nepal img {
  width: 80%;
}
.service-image {
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 6rem;
}
.service-image img {
  background: #ffffff;
  width: 100%;
  height: 100%;
  border-radius: 1rem;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  object-fit: contain;
}
.lift-shadow,
.lift-karade-img {
  transition: 0.5s;
}
.lift-shadow:hover {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
  transform: scale(1.02);
}
.lift-karade-img:hover {
  -webkit-filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.16));
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.16));
  transform: scale(1.02);
}
.top-border {
  width: 85%;
  border-top: 1px solid;
}
.vue-icon,
.about-rojgari,
.avaliable-employer-work {
  background-color: #ffeeda;
}
.rojgari {
  grid-template-columns: 2fr 1fr;
}
.rojgari p {
  font-size: 18px;
  line-height: 35px;
  color: #252525;
}
.rojgari img {
  max-width: 200px;
  width: 50%;
}
.employer-icon {
  grid-template-columns: repeat(auto-fit, minmax(10rem, 1fr));
  grid-auto-rows: 10rem;
}

.service,
.rojgari h3,
.employer {
  line-height: 54px;
  color: #b3522b;
}
.employer-box {
  grid-auto-rows: 80px;
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
}
.vue-icon {
  width: max-content;
  border-radius: 11px;
  aspect-ratio: 1/1;
}
.is-flex-wrap {
  gap: 0.5rem;
}
.tag-color {
  padding: 8px 16px;
  background: #ffdbb0;
  border-radius: 500px;
}
@media screen and (max-width: 760px) {
  section {
    padding: 2rem;
  }
  .animation {
    grid-template-columns: repeat(1, 1fr);
  }
  .hero {
    height: 60vh;
  }
  .hero img {
    display: none;
  }
  .hero .is-flex {
    place-content: center;
  }
  .map-nepal {
    grid-template-columns: 1fr;
    padding: 1rem;
  }
  .service-image {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    padding-top: 0;
  }
  .service-image img {
    width: 100%;
  }
  .service h3 {
    line-height: 37px;
  }
  .rojgari {
    grid-template-columns: 1fr;
  }
  .rojgari p {
    line-height: 30px;
  }
  .rojgari img {
    margin: auto;
  }
  .employer-icon {
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 400px) {
  section {
    padding: 1rem;
  }
  .card-box {
    padding: 1rem;
  }
}
.carousel {
  bottom: 0;
  width: 40%;
  max-width: 600px;
  height: 100%;
  max-height: 80vh;
}
.carousel .carousel-item {
  width: 100%;
  height: 400px;
  object-fit: cover;
  bottom: 0;
  left: 100%;
  transition: all 0.8s ease-out;
  opacity: 0;
  visibility: hidden;
  transform: scale(0.2);
}
.carousel .carousel-item.active {
  left: 0;
  opacity: 1;
  visibility: visible;
  transform: scale(1);
}
.carousel .carousel-item.remove {
  left: -100%;
}
.carousel .carousel-item {
  height: 100%;
}

@media screen and (max-width: 500px) {
  .display-none {
    display: none;
  }
}
body {
  margin: 0;
}
.footer-nav {
  position: fixed;
  z-index: 999;
  bottom: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 12px;
  font-family: Arial, sans-serif;
  font-weight: normal;
  color: #fff;
  text-align: center;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.footer-nav.hidden {
  opacity: 0;
  transform: translateY(100%);
}
.footer-nav.sticky {
  position: sticky;
  bottom: 0;
}
</style>
